import type { SearchResult } from '../lib/types'

interface ResultCardProps {
  result: SearchResult
  isSelected: boolean
  onSelect: (url: string) => void
}

export function ResultCard({ result, isSelected, onSelect }: ResultCardProps) {
  return (
    <div
      onClick={() => onSelect(result.url)}
      className={`
        p-4 rounded-2xl border-2 cursor-pointer transition-all duration-300
        ${
          isSelected
            ? 'border-light-accent dark:border-dark-accent bg-gradient-to-r from-light-accent/10 to-light-secondary/10 dark:from-dark-accent/20 dark:to-dark-secondary/20 shadow-cute scale-[1.02]'
            : 'border-light-paw/30 dark:border-dark-paw/30 hover:border-light-accent dark:hover:border-dark-accent hover:shadow-card bg-white/50 dark:bg-dark-bg-sub/50'
        }
      `}
    >
      <div className="flex items-start gap-3">
        <div
          className={`
            w-6 h-6 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center transition-all duration-300
            ${
              isSelected
                ? 'border-light-accent dark:border-dark-accent bg-gradient-to-br from-light-accent to-pet-coral text-white scale-110'
                : 'border-light-paw dark:border-dark-paw'
            }
          `}
        >
          {isSelected && (
            <span className="text-sm">✓</span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-light-text dark:text-dark-text truncate flex items-center gap-2">
            <span>📄</span>
            {result.title}
          </h3>
          <p className="text-sm text-light-text-sub dark:text-dark-text-sub mt-2 line-clamp-2">
            {result.snippet}
          </p>
          <a
            href={result.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="text-xs text-light-accent dark:text-dark-accent hover:underline mt-2 inline-flex items-center gap-1 truncate max-w-full"
          >
            <span>🔗</span>
            {result.url}
          </a>
        </div>
      </div>
    </div>
  )
}
